const image = [
  'image/gif',
  'image/png',
  'image/jpeg',
  'image/bmp',
  'image/webp',
  'image/ief'
];
const text = ['text/plain', 'text/html', 'text/css', 'text/javascript'];
const video = [
  'video/webm',
  'video/ogg',
  'video/x-flv',
  'video/mp4',
  'application/x-mpegURL',
  'video/MP2T',
  'video/3gpp',
  'video/quicktime',
  'video/x-msvieo',
  'video/x-ms-wmv',
  'video/mpeg'
];
const audio = [
  'audio/midi',
  'audio/mpeg',
  'audio/webm',
  'audio/ogg',
  'audio/wav',
  'audio/mp4'
];

const pdf = ['application/pdf'];
const excel = ['application/excel'];

export const isImage = (contentType) => {
  if (contentType.includes('image')) {
    return true;
  }

  return image.includes(contentType);
};

export const isText = (contentType) => {
  return text.includes(contentType);
};

export const isVideo = (contentType) => {
  return video.includes(contentType);
};

export const isAudio = (contentType) => {
  return audio.includes(contentType);
};

export const isPDF = (contentType) => {
  if (contentType.includes('pdf')) {
    return true;
  }

  return pdf.includes(contentType);
};

export const isExcel = (contentType) => {
  if (contentType.includes('image')) {
    return true;
  }

  return excel.includes(contentType);
};
